import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	vosFile: {}, // Signed VOS data
}

const getters = {
	
}


// mutations
const mutations = {
	TOGGLE_BOOLEAN_STATE(state, {key, bool}){
		eval('state.' + key + ' = bool');
	},
}

// actions
const actions = {
	toggleBooleanState({commit}, {key, bool}){
		commit('TOGGLE_BOOLEAN_STATE', {key: key, bool: bool});
	},


	// upload VOS
	uploadFile(){

	},

	// delete vos file
	deleteFile({commit, state, dispatch, getters, rootState, rootGetters}){
	},
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}